import { useUserStore } from '@roc/feature-app-core';
import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';

interface UserAgreementDialogProps {
  onNavigateToUserProfile?: () => void;
}

const PlatformUiUserAgreement = ({ onNavigateToUserProfile }: UserAgreementDialogProps) => {
  const { userStore } = useUserStore();
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('platform-ui:enable-platform-wc-styles'));
    return () => {
      window.dispatchEvent(new CustomEvent('platform-ui:disable-platform-wc-styles'));
    };
  }, []);

  useEffect(() => {
    const handler = (e: CustomEvent) => {
      const { eventName } = e.detail;
      if (eventName === 'userAgreementCompleted') {
        userStore.getUserInfoAndEntitlements(() => window.location.reload());
      } else if (eventName === 'navigateToUserProfile') {
        userStore.getUserInfoAndEntitlements(() => onNavigateToUserProfile?.());
      }
    };
    const node = ref.current;
    node?.addEventListener('platform-ui-event', handler);
    return () => node?.removeEventListener('platform-ui-event', handler);
  }, [onNavigateToUserProfile]);

  return <platform-ui id="user-agreement-dialog" component="user_agreement_dialog" ref={ref} />;
};

export const UserAgreementDialog = observer(({ onNavigateToUserProfile }: UserAgreementDialogProps) => {
  const { userStore } = useUserStore();
  const { userInformation } = userStore;

  if (!userInformation || userInformation.isInternal || userInformation.signedUserAgreement !== false) {
    return null;
  }

  return <PlatformUiUserAgreement onNavigateToUserProfile={onNavigateToUserProfile} />;
});
